// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"general-module--Wrapper--34TkK","btnToTop":"general-module--btnToTop--37L5P","arrowIconPosition":"general-module--arrowIconPosition--3vCTE"};